import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { cancelRequisition, CancelRequisitionRequest } from '../common/api/clients/mariapps.api';

export const useMariAppsCancelRequisition = () => {
    return useMutation<void, AxiosError<{ error?: string }>, CancelRequisitionRequest>({
        mutationFn: cancelRequisition,
    });
};
